class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    if (!this.notification) return;

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>{
        if(closeButton.closest('quantity-input')) return;
        closeButton.addEventListener('click', this.close.bind(this))
      }
    );
  }

  // The pop-up is rendered whenever either the Desktop or the Mobile cart type asks for
  // it, so it must only take over when it is the type configured for this viewport.
  isActiveCartUI() {
    if (!window.cartDisplay) return true;
    return window.cartDisplay.getType() === 'notification';
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    if (!this.notification) return;
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    const notificationProductDetails = document.querySelector("#cart-notification-product dl");
    if (notificationProductDetails) {
      notificationProductDetails.classList.contains("visually-hidden") ? notificationProductDetails.classList.remove("visually-hidden") : "";
    }
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState, varId, quantity, hideCartNotification) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        const parser = new DOMParser();
        let data = parsedState.sections[section.id];        
        const parsedHTML = parser.parseFromString(data, 'text/html');
        const targetElement = parsedHTML.querySelector('.cart-item');
        let dataId = ``
        if(targetElement){
          // dataId = `[id="${targetElement.getAttribute('id')}"]`;
          dataId = `[data-key-id="cart-notification-product-${varId}"]`;
        }
        if(targetElement && targetElement.querySelector('.item-quantity-notification') && quantity){
          targetElement.querySelector('.item-quantity-notification').innerHTML = `Qty ${quantity}`;
        }
        if(section.selector?.includes('undefined')){
          document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedHTML, dataId);
        }else{
          document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedHTML, section.selector);
        }
      }));

      initializeFlickity();

      if (this.header) this.header.reveal();
      if(hideCartNotification == true){
        return false;
      }
      if(!this.isActiveCartUI()){
        // This viewport is configured for the drawer (or the cart page): contents are
        // refreshed but the pop-up stays closed.
        return false;
      }
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return html.querySelector(selector).innerHTML;
    // return new DOMParser()
    //   .parseFromString(html, 'text/html')
    //   .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

window.CartDrawerItems = new CartNotification();
function initializeFlickity() {
  
  const extrasElem = document.querySelector('.cart__recommendations-wrapper');
  if (!extrasElem || typeof Flickity === 'undefined') return;

  // let slideCount = document.querySelectorAll('.product_add--extras-wrapper .cart__recommendations-product').length;
  // var extrasElem = document.querySelector('.cart__recommendations-wrapper');
  // window.matchHeight('.cart__recommendations-product .cart__recommendations--product-title');

  var flkty = new Flickity(extrasElem, {
    cellAlign: 'left',
    wrapAround: false,
    contain: true,
    pageDots: false,
    // One card per swipe on every device. freeScroll let a single drag coast past
    // several cards, which is the "grab swipe" behaviour we don't want.
    freeScroll: false,
    groupCells: 1,
    // A deliberate horizontal swipe clears this easily; thumb wobble during a
    // vertical scroll of the drawer does not (see enableCarouselSwipe).
    dragThreshold: 10,
    prevNextButtons: true,
    adaptiveHeight: false,
    arrowShape: { 
      x0: 15,
      x1: 60, y1: 50,
      x2: 70, y2: 40,
      x3: 35
    }
  });

  // let checkInterval = setInterval(() => {
  // const flickityElem = document.querySelector('.cart__recommendations-wrapper.flickity-enabled');
  
  // if (flickityElem) {
  //     setTimeout(()=>{
  //       window.dispatchEvent(new Event('resize'));
  //     },1000)      
  //     clearInterval(checkInterval);

  //   }
  // }, 100);

  // Flickity's constructor returns the existing instance for an already-enhanced element
  // and only re-applies options -- it never re-measures. This runs on every drawer open
  // and on resize, so re-measure explicitly, but only while the carousel is visible:
  // cart-display-settings hides the cart UI that is not configured for the current
  // viewport with display:none, and Flickity measures that as zero.
  if (flkty && typeof flkty.resize === 'function' && extrasElem.offsetWidth > 0) {
    flkty.resize();
  }

  if (typeof window.enableCarouselSwipe === 'function') {
    window.enableCarouselSwipe(flkty, extrasElem);
  }

}

window.addEventListener('resize', initializeFlickity);
